// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { Switch, Route, Link } from 'react-router-dom'
import { withRouter } from 'react-router'

// Internal Dependencies:
import PageHeader from 'components/PageHeader/PageHeader'
import Page from 'views/page/Page'
import Programs from 'components/Programs/Programs'
import Podcasts from 'components/Programs/Podcasts'
import Favourites from 'components/Programs/Favourites'
import SchedulePage from 'components/Schedule/SchedulePage'
import Stations from 'components/Stations/Stations'
import Program from 'views/page/Program'
// import FacebookFeed from 'components/Facebook/FacebookFeed'
import BlogFeed from 'components/Blog/BlogFeed'
import Testimonial from 'components/Testimonial/Testimonial'
import Footer from 'components/Footer/Footer'

// Redux:
import { setHasScrolledToProgramsPage } from 'actions/site'
import { getPageData } from 'actions/page'
import { setSelectedItem } from 'actions/schedule'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class MainLayout extends React.Component {
	componentDidMount() {
		// Page:
		const { params, path } = this.props.match
		const programsPages = [
			'programs',
			'podcasts',
			'favourites'
		]
		const withingProgramsPages = programsPages.includes( params.page )

		if ( withingProgramsPages ) {
			// Get the other page data now to allow for smoother switching:
			if ( 'programs' != params.page ) {
				this.props.getPost( 'programs', 'page', false, true )
			}

			if ( 'podcasts' != params.page ) {
				this.props.getPost( 'podcasts', 'page', false, true )
			}

			if ( 'favourites' != params.page ) {
				this.props.getPost( 'favourites', 'page', false, true )
			}
		}

		if ( '/' == path ) {
			this.props.getPost( 'home', 'page' )
		} else if ( '/schedule-item/:time' == path ) {
			this.props.getPost( 'schedule', 'page' )
		} else if ( params.page ) {
			if ( params.archivePageNumber ) {
				this.props.getPost( params.page, 'page', params.archivePageNumber )
			} else {
				this.props.getPost( params.page, 'page' )
			}
		} else if ( params.blog ) {
			this.props.getPost( params.blog, 'post' )
		} else if ( params.blogCategory ) {
			this.props.getPost( params.blogCategory, 'post-category' )
		} else if ( params.event ) {
			this.props.getPost( params.event, 'event' )
		}

		if ( '/schedule' != path ) {
			this.props.setSelectedItem( false )
		}
	}

	componentDidUpdate( prevProps ) {
		// Page:
		if ( this.props.match ) {
			const { params, path } = this.props.match
			const prevParams = prevProps.match.params
			const prevPath = prevProps.match.path
			const programsPages = [
				'programs',
				'podcasts',
				'favourites'
			]
			const withingProgramsPages = programsPages.includes( params.page ) && programsPages.includes( prevParams.page )

			if ( '/' == path && '/' !== prevPath ) {
				window.scrollTo( 0, siteData.page_top_pos )
				document.querySelector( '.main' ).scrollTop = 0

				this.props.getPost( 'home', 'page' )
			} else if ( '/schedule-item/:time' == path ) {
				this.props.getPost( 'schedule', 'page' )
			} else if ( '/votd-schedule/:date' == path ) {
				this.props.getPost( 'votd-schedule', 'page' )
			} else if ( params.page && prevParams.page !== params.page ) {
				if ( ! withingProgramsPages ) {
					window.scrollTo( 0, siteData.page_top_pos )
					document.querySelector( '.main' ).scrollTop = 0
				}

				if ( withingProgramsPages ) {
					// Get the other page data now to allow for smoother switching:
					if ( 'programs' != params.page ) {
						this.props.getPost( 'programs', 'page', false, true )
					}

					if ( 'podcasts' != params.page ) {
						this.props.getPost( 'podcasts', 'page', false, true )
					}

					if ( 'favourites' != params.page ) {
						this.props.getPost( 'favourites', 'page', false, true )
					}
				}

				this.props.getPost( params.page, 'page' )
			} else if ( params.page && params.archivePageNumber && prevParams.archivePageNumber !== params.archivePageNumber ) {
				window.scrollTo( 0, siteData.page_top_pos )
				document.querySelector( '.main' ).scrollTop = 0

				this.props.getPost( params.page, 'page', params.archivePageNumber )
			} else if ( params.blog && prevParams.blog !== params.blog ) {
				window.scrollTo( 0, siteData.page_top_pos )
				document.querySelector( '.main' ).scrollTop = 0

				this.props.getPost( params.blog, 'post' )
			} else if ( params.event && prevParams.event !== params.event ) {
				window.scrollTo( 0, siteData.page_top_pos )
				document.querySelector( '.main' ).scrollTop = 0

				this.props.getPost( params.event, 'event' )
			}

			if ( '/schedule' != path ) {
				this.props.setSelectedItem( false )
			}

			if ( params.page && 'programs' != params.page && 'podcasts' != params.page && 'favourites' != params.page ) {
				this.props.setHasScrolledToProgramsPage( false )
			}
		}
	}

	render() {
		const { appMode, hasSidebar, location, match, page, isMobile } = this.props
		let className = ''

		let showPageHeader = true,
			showPrimaryContent = true,
			showSecondaryContent = true,
			showPrograms = false,
			showPodcasts = false,
			showFavourites = false,
			showSchedule = false,
			showStations = false,
			showTestimonial = true

		if ( page && page.template ) {
			className += ` page-${page.template}`
		}

		if ( match.params.page && 'programs' == match.params.page ) {
			showPageHeader = false
			showPrograms = true
			showPrimaryContent = false
			showSecondaryContent = false
			showTestimonial = false
		}

		if ( match.params.page && 'podcasts' == match.params.page ) {
			showPageHeader = false
			showPodcasts = true
			showPrimaryContent = false
			showSecondaryContent = false
			showTestimonial = false
		}

		if ( match.params.page && 'favourites' == match.params.page ) {
			showPageHeader = false
			showFavourites = true
			showPrimaryContent = false
			showSecondaryContent = false
			showTestimonial = false
		}

		if ( ( match.params.page && 'schedule' == match.params.page ) || match.params.time ) {
			showPageHeader = false
			showSchedule = true
			showPrimaryContent = false
			showSecondaryContent = false
			showTestimonial = false
		}

		if ( match.params.page && 'stations' == match.params.page ) {
			showPageHeader = false
			showStations = true
			showPrimaryContent = false
			showSecondaryContent = false
			showTestimonial = false
		}

		if ( page && 'listen' == page.template && isMobile ) {
			showPageHeader = false
		}

		return (
			<div className={ className }>
				{ showPageHeader &&
					<PageHeader match={ match } location={ location } />
				}

				<div className="main-inner">
					{ showPrimaryContent &&
						<div className="primary-wrap">
							<div className="primary-content">
								<Switch key={ location.key } location={ location }>
									<Route path="/" exact component={ Page } />

									<Route path="/:page" exact component={ Page } />
									<Route path="/program/:program" exact component={ Program } />
									<Route path="/programs/:program" exact component={ Program } />
									<Route path="/schedule-item/:time" exact component={ Page } />
									<Route path="/votd-schedule" exact component={ Page } />
									<Route path="/votd-schedule/:date" exact component={ Page } />
									<Route path="/news/:blog" exact component={ Page } />
									<Route path="/blog/:blog" exact component={ Page } />
									<Route path="/event/:event" exact component={ Page } />
									<Route path="/:page/page/:archivePageNumber" exact component={ Page } />
									<Route path="/:parent/:page" exact component={ Page } />
									<Route component={ Page } />
								</Switch>
							</div>
						</div>
					}

					{ showSecondaryContent &&
						<div className="secondary-wrap">
							<div className="secondary-content">
								<aside className="radio-frequencies">
									<Link to="/stations">
										<h3>Tune In:</h3>

										<div className="-frequencies">
											<div className="-frequency">87.6 MHz</div>
											<div className="-frequency">87.8 MHz</div>
											<div className="-frequency">88.0 MHz</div>
										</div>
									</Link>
								</aside>

								{ ! showPrograms && ! showSchedule &&
									<aside className="sidebar-news">
										<BlogFeed />
									</aside>
								}

								<aside className="social">
									<h3>Connect:</h3>

									<div className="-socials">
										<a className="-facebook" href="https://www.facebook.com/faithfmaustralia" target="_blank" rel="noopener">
											<i className="icon-facebook-official" aria-hidden="true"></i>
										</a>

										<a className="-youtube" href="https://www.youtube.com/faithfmaustralia" target="_blank" rel="noopener">
											<i className="icon-youtube-square" aria-hidden="true"></i>
										</a>

										<a className="-instagram" href="https://www.instagram.com/faithfmaustralia" target="_blank" rel="noopener">
											<i className="icon-instagram" aria-hidden="true"></i>
										</a>

										<a className="-twitter" href="https://twitter.com/faithfmlive" target="_blank" rel="noopener">
											<i className="icon-twitter-square" aria-hidden="true"></i>
										</a>
									</div>
								</aside>
							</div>
						</div>
					}

					{ ( showPrograms || showPodcasts || showFavourites || showSchedule || showStations ) &&
						<div className="wide-sections">
							{ showPrograms &&
								<Programs { ...this.props } />
							}

							{ showPodcasts &&
								<Podcasts { ...this.props } />
							}

							{ showFavourites &&
								<Favourites { ...this.props } />
							}

							{ showSchedule &&
								<SchedulePage { ...this.props } />
							}

							{ showStations &&
								<Stations { ...this.props } />
							}
						</div>
					}

					{ appMode &&
						<Footer />
					}
				</div>

				{ showTestimonial &&
					<Testimonial />
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		appMode: state.site.appMode,
		hasSidebar: state.site.hasSidebar,
		page: state.page.selected,
		isMobile: state.site.isMobile
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber = false, requestOnly = false ) => {
			dispatch( getPageData( slug, type, archivePageNumber, requestOnly ) )
		},

		setSelectedItem( key ) {
			dispatch( setSelectedItem( key ) )
		},

		setHasScrolledToProgramsPage( bool ) {
			dispatch( setHasScrolledToProgramsPage( bool ) )
		}
	}
}

export default withRouter(
	connect( mapStateToProps, mapDispatchToProps )( MainLayout )
)
